import  { useState, useEffect } from "react";
import { useSnapshot } from "valtio";
import { Navigate } from "react-router-dom";
import { permissionStore, PermissionAction, ResourceType } from "@/stores/permissionStore";
import { toast } from "sonner";
import TestAnalytics from "@/components/analysis/testAnalysis";
import MaterialAnalytics from "@/components/analysis/materialAnalysis";

export default function AnalyticsPage() {
  const permSnap = useSnapshot(permissionStore);
  const [view, setView] = useState("material");
  
  // Permission checks
  const canReadAnalytics = permSnap.can(PermissionAction.READ, ResourceType.ANALYTICS);
  
  useEffect(() => {
    if (!canReadAnalytics) {
      toast.error("You don't have permission to view analytics");
    }
  }, [canReadAnalytics]);
  
  if (!canReadAnalytics) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <div>
      <div className="flex gap-4 mb-4">
        <button
          onClick={() => setView("material")}
          className={`px-4 py-2 rounded-lg ${
            view === "material" ? "bg-[#5D93A5] text-white" : "bg-gray-200"
          }`}
        >
          Material Analytics
        </button>
        <button
          onClick={() => setView("test")}
          className={`px-4 py-2 rounded-lg ${
            view === "test" ? "bg-[#5D93A5] text-white" : "bg-gray-200"
          }`}
        >
          Test Analytics
        </button>
      </div>

      {view === "material" ? <MaterialAnalytics /> : <TestAnalytics />}
    </div>
  );
}
